import "./fonts.css2.js";
const s = "https://static.parastorage.com/services/fonts-data/dist/fonts.n4jkv23h7cty2lxtptuz.css";
export {
  s as default
};
//# sourceMappingURL=fonts.css.js.map
